import React from 'react'
import BrokerageSvg from 'images/modules/Manage/i-menu-brokerage.svg?raw'

export { default as BrokerageUrl } from 'images/modules/Manage/i-menu-brokerage.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: BrokerageSvg}} />
)
